import React, { useRef, useEffect } from 'react'
import form from '../../../form'

const ContactForm4Column = () => {
  const wrapper = useRef(null)
  useEffect(() => {
    form(wrapper.current)
  }, [])
  return (
    <div className='grid-x ticket__contact-fields' ref={wrapper}>
      <div className='medium-2 cell'>
        <label
          className='ticket__label ticket-landing__label input-block'
          data-validateable-block
        >
          <select
            className='ticket__input ticket-landing__input input-field'
            name='title'
            required
            data-validateable-input
          >
            <option selected disabled value=''>
              Title
            </option>
            <option>Mr.</option>
            <option>Ms.</option>
          </select>
        </label>
      </div>
      <div className='medium-10 large-3 cell'>
        <label
          className='ticket__label ticket-landing__label input-block'
          data-validateable-block
        >
          <input
            className='ticket__input ticket-landing__input input-field'
            placeholder='Name'
            name='name'
            required
            data-validateable-input
          />
          <div className='input-error'>Enter name</div>
        </label>
      </div>
      <div className='medium-6 large-3 cell'>
        <label
          className='ticket__label ticket-landing__label input-block'
          data-validateable-block
        >
          <input
            className='input-field ticket__input ticket-landing__input'
            type='tel'
            name='phone'
            placeholder='+1234567890'
            pattern='[+].{10,}'
            data-validateable-input
            required
          />
          <div className='input-error'>Enter phone</div>
        </label>
      </div>
      <div className='medium-6 large-4 cell'>
        <label
          className='ticket__label ticket-landing__label input-block'
          data-validateable-block
        >
          <input
            className='ticket__input ticket-landing__input input-field'
            placeholder='Email'
            name='email'
            type='email'
            required
            data-validateable-input
          />
          <div className='input-error'>Enter email</div>
        </label>
      </div>
      <div className='small-12 cell'>
        <label className='ticket__label ticket-landing__label input-block'>
          <textarea
            className='ticket__input ticket-landing__input input-field'
            placeholder='Message'
            name='message'
            rows='3'
            maxLength='1000'
          ></textarea>
        </label>
      </div>
    </div>
  )
}

export default ContactForm4Column
